import React from 'react'
import PropTypes from 'prop-types'
import AlertContainer from 'react-alert'
import { deleteFile, deleteFiles } from '../../api/files'
import FileGalleryPage from './FileGalleryPage'

class FileGalleryPageContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    const filters = {}
    const path = props.match.url.split('/')[1]

    if (path === 'images') {
      filters.type = 'image'
    } else if (path === 'documents') {
      filters.type = 'not-image'
    }

    this.state = {
      filters: filters,
      refreshList: 0
    }
  }

  onSelect = (e, data) => {
    this.props.history.push(`/files/${data.id}/replace`)
  }

  onDeleteFile = async file => {
    const id = file.id
    try {
      await deleteFile(id)
      this.msgSuccess.show('Successfully deleted file', { type: 'success', time: 6000 })
      setTimeout(() => {
        this.setState({refreshList: new Date().getTime()})
      }, 5000)
    } catch (error) {
      console.info('error', error)
      const errorMessage = error.data ? error.data.message : 'Could not delete file'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      this.setState({isReplacing: false})
    }
  }

  onDeleteFiles = async files => {
    const fileIDs = files.map(file => file.id)
    try {
      await deleteFiles(fileIDs)
      this.msgSuccess.show('Successfully deleted files', { type: 'success', time: 6000 })
      setTimeout(() => {
        this.setState({refreshList: new Date().getTime()})
      }, 5000)
    } catch (error) {
      console.info('error', error)
      const errorMessage = error.data ? error.data.message : 'Could not delete file'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      this.setState({isReplacing: false})
    }
  }

  componentWillReceiveProps (newProps) {
    const path = newProps.match.url.split('/')[1]
    const filters = {}
    if (path === 'images') {
      filters.type = 'image'
    } else if (path === 'documents') {
      filters.type = 'not-image'
    }
    this.setState({ filters })
  }

  render () {
    const methods = {
      onSelect: this.onSelect,
      onDeleteFile: this.onDeleteFile,
      onDeleteFiles: this.onDeleteFiles
    }

    const dangerAlertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'dark',
      time: 5000,
      transition: 'scale'
    }

    const successAlertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'dark',
      time: 5000,
      transition: 'scale'
    }

    return <div>
      <FileGalleryPage {...this.props} {...this.state} {...methods} />
      <AlertContainer ref={a => (this.msg = a)} {...dangerAlertOptions} />
      <AlertContainer ref={a => (this.msgSuccess = a)} {...successAlertOptions} />
    </div>
  }
}

FileGalleryPageContainer.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
}

export default FileGalleryPageContainer



// WEBPACK FOOTER //
// ./src/pages/FileGalleryPage/FileGalleryPageContainer.js